import React from 'react';
import { Box } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

// Custom bar shape to apply border radius
const CustomBar = (props) => {
  const { fill, x, y, width, height } = props;
  const radius = 10; 

  return (
    <g>
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        fill={fill}
        rx={radius}  
        ry={radius} 
      />
    </g>
  );
};


// const CustomTooltip = ({ payload, label, active }) => {
//     if (active && payload && payload.length) {
//       const value = payload[0].value; 
//       return (
//         <div style={{ background: 'none', borderRadius: '25px', padding: '10px' }}>
//           <p>{`${label} : ${value}`}</p>
//         </div>
//       );
//     }
//     return null;
//   };
  
const CustomTooltip = ({ payload, label, active }) => {
  if (active && payload && payload.length) {
      const value = payload[0].value;
      const dataKey = payload[0].dataKey; // Get the key associated with the data (e.g., "totalRevenue" or "totalSales")
      const isRevenue = dataKey === "totalRevenue"; // Check if the key is for "Revenue"
      
      return (
          <div style={{ background: 'none', borderRadius: '25px', padding: '10px' }}>
              <p>{`${label} : ${isRevenue ? `$${value}` : value}`}</p> {/* Add '$' only for Revenue */}
          </div>
      );
  }
  return null;
};



// Custom Graph Component with Fixed Bar Color and Radius
const CustomGraph = ({ data, dataKey }) => (
    
  <ResponsiveContainer width="100%" height={400}  style={{ marginLeft: 0, marginRight: 0 }} >
    <BarChart data={data}>
      <defs>
        <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="100%" spreadMethod="reflect">
          <stop offset="0" stopColor="#3F715C" />
          <stop offset="1" stopColor="#3F715C" />
        </linearGradient>
      </defs>
      <CartesianGrid strokeDasharray="0" stroke="#ccc" vertical={false} />
      <XAxis dataKey="name" />
      <YAxis axisLine={false} tickLine={false}    
       tickFormatter={(value) => {
        return dataKey === 'totalRevenue' ? `$${value}` : value;
      }}
        />

      {/* <Tooltip cursor={{fill:'none'}} contentStyle={{background:'none',borderRadius:'25px'}} /> */}
      <Tooltip content={<CustomTooltip />} cursor={{ fill: 'none' }} />
      <Bar dataKey={dataKey} fill="url(#colorUv)" shape={<CustomBar />} />
    </BarChart>
  </ResponsiveContainer>
);

// Custom Card with Graph Component
const CustomCardWithGraph = ({ title, data, dataKey, customStyles }) => (

  <Box
    sx={{
      borderRadius: '24px',
      background: '#FFF',
      boxShadow: '3px 2px 20px 0px rgba(0, 0, 0, 0.04)',
      padding: '10px',
      ...customStyles,
    }}
  >
    {title && (
      <Box sx={{ mb: 2, fontWeight: 'bold', fontSize: '16px',paddingLeft:'10px' }}>
        {title}
      </Box>
    )}
    <CustomGraph data={data} dataKey={dataKey} />
  </Box>
);

export default CustomCardWithGraph;
